import { render, staticRenderFns } from "./ListCustomView.vue?vue&type=template&id=845b79b0&"
import script from "./ListCustomView.vue?vue&type=script&lang=js&"
export * from "./ListCustomView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports